// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Dreams__centerText___DeKPI {
    text-align: center;
}

.Dreams__rowId___d22Xp {
    font-style: italic;
    font-weight: bold;
}

.Dreams__rowLinkIcon___Un54X {
    color: dimgray;
    margin-left: 0.2em;
    position: relative;
    top: 1px;
}

.Dreams__rowDeleteButton___PXO4G {
    margin-left: 1em;
    font-size: 10px;
}

.Dreams__underline___G1_FI {
    text-decoration: underline;
}

.Dreams__rowHighlighted____JIfj {
    background: #373832;
}

.Dreams__colorWhite___caMBP {
    color: white;
}

.Dreams__options___Zowzn {
    color: gray;
    margin-bottom: 8px;
}

.Dreams__searchError___eVPFv {
    margin-bottom: 10px;
    color: red;
}

.Dreams__resultsTransition___vEXsF {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    opacity: 0;
    transition: opacity 220ms ease;
    will-change: opacity;
}

.Dreams__resultsTransitionVisible___iUD0Q {
    opacity: 1;
}

.Dreams__difficultyContainer___waKYM {
    margin-bottom: 0.25em;
}

.Dreams__difficultySelector___uMUAQ {
    max-width: 65px;
}

.Dreams__emotionSelector___v7iTp {
    max-width: 62px;
    margin-bottom: 1em;
}

.Dreams__attributeSelector___qxyvi {
    max-width: 140px;
    margin-bottom: 1em;
}

.Dreams__inXYearsText___rn52q {
    font-weight: bold;
    color: gray;
    font-size: 13px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"centerText": `Dreams__centerText___DeKPI`,
	"rowId": `Dreams__rowId___d22Xp`,
	"rowLinkIcon": `Dreams__rowLinkIcon___Un54X`,
	"rowDeleteButton": `Dreams__rowDeleteButton___PXO4G`,
	"underline": `Dreams__underline___G1_FI`,
	"rowHighlighted": `Dreams__rowHighlighted____JIfj`,
	"colorWhite": `Dreams__colorWhite___caMBP`,
	"options": `Dreams__options___Zowzn`,
	"searchError": `Dreams__searchError___eVPFv`,
	"resultsTransition": `Dreams__resultsTransition___vEXsF`,
	"resultsTransitionVisible": `Dreams__resultsTransitionVisible___iUD0Q`,
	"difficultyContainer": `Dreams__difficultyContainer___waKYM`,
	"difficultySelector": `Dreams__difficultySelector___uMUAQ`,
	"emotionSelector": `Dreams__emotionSelector___v7iTp`,
	"attributeSelector": `Dreams__attributeSelector___qxyvi`,
	"inXYearsText": `Dreams__inXYearsText___rn52q`
};
module.exports = ___CSS_LOADER_EXPORT___;
